import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CloseDialog, OpenDialog } from './help-button.actions';
import { patch } from '@ngxs/store/operators';

export type HelpButtonStateModel = {
  title: string;
  content: string;
  open: boolean;
};

export const initialState: HelpButtonStateModel = {
  title: '',
  content: '',
  open: false,
};

@State<HelpButtonStateModel>({
  name: 'helpButton',
  defaults: initialState,
})
@Injectable()
export class HelpButtonState {

  @Selector()
  static open(state: HelpButtonStateModel): boolean {
    return state.open;
  }

  @Selector()
  static title(state: HelpButtonStateModel): string {
    return state.title;
  }

  @Selector()
  static content(state: HelpButtonStateModel): string {
    return state.content;
  }

  @Action(OpenDialog)
  openDialog(context: StateContext<HelpButtonStateModel>, { title, content }: OpenDialog) {
    context.setState(
      patch({
        open: true,
        title,
        content,
      }),
    );
  }

  @Action(CloseDialog)
  closeDialog(context: StateContext<HelpButtonStateModel>) {
    context.setState(
      patch({
        open: false,
        title: '',
        content: '',
      }),
    );
  }
}
